export const GET_COST_CENTER_SUCCESS = "GET_COST_CENTER_SUCCSS";
export const GET_COST_CENTER_ERROR = "GET_COST_CENTER_ERROR";
export const GET_COMPANIES_SUCCESS = "GET_COMPANIES_SUCCESS";
export const GET_COMPANIES_ERROR = "GET_COMPANIES_ERROR";
export const GET_MY_USER_DETAIL_SUCCESS = "GET_MY_USER_DETAIL_SUCCESS";
export const GET_MY_USER_DETAIL_ERROR = "GET_MY_USER_DETAIL_ERROR";
export const GET_FİRM_NAMES_SUCCESS = "GET_FİRM_NAMES_SUCCESS";
export const GET_FİRM_NAMES_ERROR = "GET_FİRM_NAMES_ERROR";
export const GET_STARTİNG_WORK_EMPLOYEES_SUCCESS =
  "GET_STARTİNG_WORK_EMPLOYEES_SUCCESS";
export const GET_STARTİNG_WORK_EMPLOYEES_ERROR =
  "GET_STARTİNG_WORK_EMPLOYEES_ERROR";
export const GET_RELATED_MEMBER__NAME_LİST_SUCCESS =
  "GET_RELATED_MEMBER__NAME_LİST_SUCCESS";
export const GET_RELATED_MEMBER__NAME_LİST_ERROR =
  "GET_RELATED_MEMBER__NAME_LİST_ERROR ";
export const GET_PERSONAL_TYPE_LİST_SUCCESS = "GET_PERSONAL_TYPE_LİST_SUCCESS";
export const GET_PERSONAL_TYPE_LİST_ERROR = "GET_PERSONAL_TYPE_LİST_ERROR";
export const GET_PROJECT_NAME_LİST_SUCCESS = "GET_PROJECT_NAME_LİST_SUCCESS";
export const GET_PROJECT_NAME_LİST_ERROR = "GET_PROJECT_NAME_LİST_ERROR";
export const GET_PROJECT_STATUS_LİST_SUCCESS =
  "GET_PROJECT_STATUS_LİST_SUCCESS";
export const GET_PROJECT_STATUS_LİST_ERROR = "GET_PROJECT_STATUS_LİST_ERROR";
export const GET_PROJECT_ASSİGNMENT_LİST_SUCCESS =
  "GET_PROJECT_ASSİGNMENT_LİST_SUCCESS";
export const GET_PROJECT_ASSİGNMENT_LİST_ERROR =
  "GET_PROJECT_ASSİGNMENT_LİST_ERROR";
export const GET_ALL_CUSTOMER_SUCCESS = "GET_ALL_CUSTOMER_SUCCESS";
export const GET_ALL_CUSTOMER_ERROR = "GET_ALL_CUSTOMER_ERROR";
export const GET_ALL_PASSIVE_CUSTOMER_SUCCESS =
  "GET_ALL_PASSIVE_CUSTOMER_SUCCESS";
export const GET_ALL_PASSIVE_CUSTOMER_ERROR = "GET_ALL_PASSIVE_CUSTOMER_ERROR";
export const GET_PERSONNEL_NAME_FOR_PROJECT_ASSIGNMENT_SUCCESS =
  "GET_PERSONNEL_NAME_FOR_PROJECT_ASSIGNMENT_SUCCESS";
export const GET_PERSONNEL_NAME_FOR_PROJECT_ASSIGNMENT_ERROR =
  "GET_PERSONNEL_NAME_FOR_PROJECT_ASSIGNMENT_ERROR";
export const GET_LEAVİNG_PERSONAL_LİST_SUCCESS =
  "GET_LEAVİNG_PERSONAL_LİST_SUCCESS";
export const GET_LEAVİNG_PERSONAL_LİST_ERROR =
  "GET_LEAVİNG_PERSONAL_LİST_ERROR";
export const GET_PROJECT_DETAIL_SUCCESS = "GET_PROJECT_DETAIL_SUCCESS";
export const GET_PROJECT_DETAIL_ERROR = "GET_PROJECT_DETAIL_ERROR";
export const GET_PROJECT_STATUS_PARAMETER_SUCCESS =
  "GET_PROJECT_STATUS_PARAMETER_SUCCESS";
export const GET_PROJECT_STATUS_PARAMETER_ERROR =
  "GET_PROJECT_STATUS_PARAMETER_ERROR";
export const GET_CAPACITY_INFO_SUCCESS = "GET_CAPACITY_INFO_SUCCESS";
export const GET_CAPACITY_INFO_ERROR = "GET_CAPACITY_INFO_ERROR";
export const GET_PROJECT_PERSONNEL_SALARY_SUCCESS =
  "GET_PROJECT_PERSONNEL_SALARY_SUCCESS";
export const GET_PROJECT_PERSONNEL_SALARY_ERROR =
  "GET_PROJECT_PERSONNEL_SALARY_ERROR";

export const GET_INSOURCE_PERSONAL_SUCCESS = "GET_INSOURCE_PERSONAL_SUCCESS";
export const GET_INSOURCE_PERSONAL_ERROR = "GET_INSOURCE_PERSONAL_ERROR";

export const GET_FILTER_SECTION_PROJECT_INFO_SUCCESS =
  "GET_FILTER_SECTION_PROJECT_INFO_SUCCESS";
export const GET_FILTER_SECTION_PROJECT_INFO_ERROR =
  "GET_FILTER_SECTION_PROJECT_INFO_ERROR";

export const GET_PROJECT_CLOSING_REPORT_SUCCESS =
  "GET_PROJECT_CLOSING_REPORT_SUCCESS";
export const GET_PROJECT_CLOSING_REPORT_ERROR =
  "GET_PROJECT_CLOSING_REPORT_ERROR";

export const GET_ALL_PERSONNEL_LİST_SUCCESS = "GET_ALL_MEMBER_LİST_SUCCESS";
export const GET_ALL_PERSONNEL_LİST_ERROR = "GET_ALL_MEMBER_LİST_ERROR";
export const GET_ALL_MEMBER_LİST_FOR_POSİTİON_SUCCESS =
  "GET_ALL_MEMBER_LİST_FOR_POSİTİON_SUCCESS";
export const GET_ALL_MEMBER_LİST_FOR_POSİTİON_ERROR =
  "GET_ALL_MEMBER_LİST_FOR_POSİTİON_ERROR";
export const GET_MAIN_TECHNOLOGIES_LIST_SUCCESS =
  "GET_MAIN_TECHNOLOGIES_LIST_SUCCESS";
export const GET_MAIN_TECHNOLOGIES_LIST_ERROR =
  "GET_MAIN_TECHNOLOGIES_LIST_ERROR";
export const GET_SUB_TECHNOLOGIES_LIST_SUCCESS =
  "GET_SUB_TECHNOLOGIES_LIST_SUCCESS";
export const GET_SUB_TECHNOLOGIES_LIST_ERROR =
  "GET_SUB_TECHNOLOGIES_LIST_ERROR";
export const GET_LANGUAGE_LİST_SUCCESS = "GET_LANGUAGE_LİST_SUCCESS";
export const GET_LANGUAGE_LİST_ERROR = "GET_LANGUAGE_LİST_ERROR";
export const GET_LANGUAGE_LEVEL_LİST_SUCCESS =
  "GET_LANGUAGE_LEVEL_LİST_SUCCESS";
export const GET_LANGUAGE_LEVEL_LİST_ERROR = "GET_LANGUAGE_LEVEL_LİST_ERROR";
export const GET_COUNTRY_LİST_SUCCESS = "GET_COUNTRY_LİST_SUCCESS";
export const GET_COUNTRY_LİST_ERROR = "GET_COUNTRY_LİST_ERROR";
export const GET_CITY_LİST_SUCCESS = "GET_CITY_LİST_SUCCESS";
export const GET_CITY_LİST_ERROR = "GET_CITY_LİST_ERROR";
export const GET_TOWN_LİST_BY_CITY_SUCCESS = "GET_TOWN_LİST_BY_CITY_SUCCESS";
export const GET_TOWN_LİST_BY_CITY_ERROR = "GET_TOWN_LİST_BY_CITY_ERROR";
export const GET_COLLAGE_LİST_SUCCESS = "GET_COLLAGE_LİST_SUCCESS";
export const GET_COLLAGE_LİST_ERROR = "GET_COLLAGE_LİST_ERROR";
export const GET_DEPARTMENT_LİST_SUCCESS = "GET_DEPARTMENT_LİST_SUCCESS";
export const GET_DEPARTMENT_LİST_ERROR = "GET_DEPARTMENT_LİST_ERROR";
export const GET_TECHNICICAL_SELECT_TREE_LIST_SUCCESS =
  "GET_TECHNICICAL_SELECT_TREE_LIST_SUCCESS";
export const GET_TECHNICICAL_SELECT_TREE_LIST_ERROR =
  "GET_TECHNICICAL_SELECT_TREE_LIST_ERROR";
export const GET_TECHNİC_GROUP_MAİN_LİST_SUCCESS =
  "GET_TECHNİC_GROUP_MAİN_LİST_SUCCESS";
export const GET_TECHNİC_GROUP_MAİN_LİST_ERROR =
  "GET_TECHNİC_GROUP_MAİN_LİST_ERROR";
export const GET_ALL_TECHNICAL_GROUP_SUCCESS =
  "GET_ALL_TECHNICAL_GROUP_SUCCESS";
export const GET_ALL_TECHNICAL_GROUP_ERROR = "GET_ALL_TECHNICAL_GROUP_ERROR";
export const GET_DOMAİN_MAİN_GROUP_LİST_SUCCESS =
  "GET_DOMAİN_MAİN_GROUP_LİST_SUCCESS";
export const GET_DOMAİN_MAİN_GROUP_LİST_ERROR =
  "GET_DOMAİN_MAİN_GROUP_LİST_ERROR";
export const GET_DOMAİN_SUB_GROUP_LİST_SUCCESS =
  "GET_DOMAİN_SUB_GROUP_LİST_SUCCESS";
export const GET_DOMAİN_SUB_GROUP_LİST_ERROR =
  "GET_DOMAİN_SUB_GROUP_LİST_ERROR";
export const GET_SEARCHED_PERSONEL_DETAIL_SUCCESS =
  "GET_SEARCHED_PERSONEL_DETAIL_SUCCESS";
export const GET_MEMBER_COLLAGE_LİST_SUCCESS =
  "GET_MEMBER_COLLAGE_LİST_SUCCESS";
export const GET_MEMBER_COLLAGE_LİST_ERROR = "GET_MEMBER_COLLAGE_LİST_ERROR";
export const GET_MEMBER_TECHNİC_LİST_SUCCESS =
  "GET_MEMBER_TECHNİC_LİST_SUCCESS";
export const GET_MEMBER_TECHNİC_LİST_ERROR = "GET_MEMBER_TECHNİC_LİST_ERROR";
export const GET_PERSONAL_COMMUNİCATİON_LEVEL_LİST_SUCCESS =
  "GET_PERSONAL_COMMUNİCATİON_LEVEL_LİST_SUCCESS";
export const GET_PERSONAL_COMMUNİCATİON_LEVEL_LİST_ERROR =
  "GET_PERSONAL_COMMUNİCATİON_LEVEL_LİST_ERROR";
export const GET_GRADUATION_STATUS_LIST_SUCCESS =
  "GET_GRADUATION_STATUS_LIST_SUCCESS";
export const GET_GRADUATION_STATUS_LIST_ERROR =
  "GET_GRADUATION_STATUS_LIST_ERROR";
export const GET_MILITARY_SERVICE_STATUS_LIST_SUCCESS =
  "GET_MILITARY_SERVICE_STATUS_LIST_SUCCESS";
export const GET_MILITARY_SERVICE_STATUS_LIST_ERROR =
  "GET_MILITARY_SERVICE_STATUS_LIST_ERROR";
export const GET_DRIVERS_LICENSE_LIST_SUCCESS =
  "GET_DRIVERS_LICENSE_LIST_SUCCESS";
export const GET_DRIVERS_LICENSE_LIST_ERROR = "GET_DRIVERS_LICENSE_LIST_ERROR";
export const GET_TECHNIC_LIST_SUCCESS = "GET_TECHNIC_LIST_SUCCESS";
export const GET_TECHNIC_LIST_ERROR = "GET_TECHNIC_LIST_ERROR";
export const GET_PERSONAL_ABİLİTY_LİST_SUCCESS =
  "GET_PERSONAL_ABİLİTY_LİST_SUCCESS";
export const GET_PERSONAL_ABİLİTY_LİST_ERROR =
  "GET_PERSONAL_ABİLİTY_LİST_ERROR";
export const GET_COMMUNICATION_PARAMETER_LIST_SUCCESS =
  "GET_COMMUNICATION_PARAMETER_LIST_SUCCESS";
export const GET_COMMUNICATION_PARAMETER_LIST_ERROR =
  "GET_COMMUNICATION_PARAMETER_LIST_ERROR";
export const GET_POSITION_LIST_BY_TECHNIC_GROUP_SUCCESS =
  "GET_POSITION_LIST_BY_TECHNIC_GROUP_SUCCESS";
export const GET_POSITION_LIST_BY_TECHNIC_GROUP_ERROR =
  "GET_POSITION_LIST_BY_TECHNIC_GROUP_ERROR";
export const GET_POSITION_LIST_BY_COMPANY_SUCCESS =
  "GET_POSITION_LIST_BY_COMPANY_SUCCESS";
export const GET_POSITION_LIST_BY_COMPANY_ERROR =
  "GET_POSITION_LIST_BY_COMPANY_ERROR";
export const GET_POSITION_LIST_BY_PROJECT_SUCCESS =
  "GET_POSITION_LIST_BY_PROJECT_SUCCESS";
export const GET_POSITION_LIST_BY_PROJECT_ERROR =
  "GET_POSITION_LIST_BY_PROJECT_ERROR";
export const GET_POSITION_LIST_SUCCESS = "GET_POSITION_LIST_SUCCESS";
export const GET_POSITION_LIST_ERROR = "GET_POSITION_LIST_ERROR";
export const GET_NAV_CANDIDATE_SEARCH_SUCCESS =
  "GET_NAV_CANDIDATE_SEARCH_SUCCESS";
export const GET_NAV_CANDIDATE_SEARCH_ERROR = "GET_NAV_CANDIDATE_SEARCH_ERROR";
export const GET_ALL_VERSIONS_SUCCESS = "GET_ALL_VERSIONS_SUCCESS";
export const GET_ALL_VERSIONS_ERROR = "GET_ALL_VERSIONS_ERROR";
export const CREATE_VERSION_SUCCESS = "CREATE_VERSION_SUCCESS";
export const CREATE_VERSION_ERROR = "CREATE_VERSION_ERROR";
export const UPDATE_VERSION_SUCCESS = "UPDATE_VERSION_SUCCESS";
export const UPDATE_VERSION_ERROR = "UPDATE_VERSION_ERROR";
export const DELETE_VERSION_SUCCESS = "DELETE_VERSION_SUCCESS";
export const DELETE_VERSION_ERROR = "DELETE_VERSION_ERROR";

export interface AllPersonnel {
  name: string;
  phoneNo: string;
  email: string;
}
export interface Member {
  id: number;
  userName: string;
}
export interface UserDetail {
  id: number;
  userName: string;
}
export interface CostCenter {
  id: number;
}
export interface Companies {
  id: number;
}

export interface CustomerList {
  id: number;
}
export interface PassiveCustomerList {
  id: number;
}
export interface PersonnelNameForProjectAssignmentList {}
export interface CurrentDebt {
  firmName: string;
  input: string;
  debtDate: Date;
  costCenterCode: number;
  companies: number;
}
export interface MainCostCenter {
  name: string;
}
export interface SubCostCenter {
  name: string;
}
export interface CostCenterList {
  companies: number;
  mainGroupName: string;
}
export interface TeknoparkList {}
export interface TeknoparkUpdateList {}
export interface CostCenterDetail {
  name: string;
}
export interface Firm {
  firmName: string;
}
export interface LanguageLevelList {}
export interface CountryList {}
export interface CityList {}
export interface TownList {
  id: number;
  name: string;
  townName?: string;
  cityId?: number;
}
export interface CollageList {}
export interface DepartmentList {}
export interface StartingWorkEmployees {}
export interface TechnoparkNameList {}
export interface ProjectNameList {}

export interface RelatedMemberNameList {}
export interface PersonalTypeList {}

export interface ProjectAssignmentList {}

export interface LeavingPersonalList {}
export interface AllTechnoparkNameList {}
export interface SubTechnologiesList {}
export interface TechnicalSelectTreeList {}
export interface TechnicGroupMainList {}
export interface MemberTechnicList {
  memberId: number;
}

export interface TechnicalList {}
export interface LanguageList {}
export interface DomainMainGroupList {}
export interface DomainSubGroupList {}
export interface MemberCollageList {
  memberId: number;
}
export interface PersonalCommunicationLevelList {}
export interface GraduationStatusList {}
export interface MilitaryServiceStatusList {}
export interface DriversLicenseList {}
export interface TechnicList {}
export interface PersonalAbilityList {}
export interface CommunicationParameterList {
  // Guid -- BE Data/GetCommunicationParameterList uuid donduruyor (upstream'de int'ti).
  id: string;
  name: string;
  // ba2026f: CommunicationParameter.IsAdress/IsTel/IsMail. Opsiyonel birakildi cunku eski
  // BE surumune karsi calisan bir FE'de alanlar hic gelmeyebilir.
  isAdress?: boolean;
  isTel?: boolean;
  isMail?: boolean;
}

export interface PositionList {
  technicalId: string | number;
  priority: string | number;
  workingModelId: string | number;
  projectTypeId: string | number;
}

export interface PositionListTechnicGroup {}
export interface PositionListByCompany {
  companyName: string;
}
export interface PositionListByProject {
  projectId: string | number;
}
export interface NavCandidateListItem {
  Id: string;
  NameSurname: string | null;
}

interface getPositionListSuccess {
  type: typeof GET_POSITION_LIST_SUCCESS;
  payload: PositionList[];
}

interface getPositionListError {
  type: typeof GET_POSITION_LIST_ERROR;
  payload: string;
}

interface getPositionListTechnicGroupSuccess {
  type: typeof GET_POSITION_LIST_BY_TECHNIC_GROUP_SUCCESS;
  payload: PositionListTechnicGroup[];
}

interface getPositionListTechnicGroupError {
  type: typeof GET_POSITION_LIST_BY_TECHNIC_GROUP_ERROR;
  payload: string;
}

interface getPositionListByCompanySuccess {
  type: typeof GET_POSITION_LIST_BY_COMPANY_SUCCESS;
  payload: PositionListByCompany[];
}

interface getPositionListByCompanyError {
  type: typeof GET_POSITION_LIST_BY_COMPANY_ERROR;
  payload: string;
}

interface getPositionListByProjectSuccess {
  type: typeof GET_POSITION_LIST_BY_PROJECT_SUCCESS;
  payload: PositionListByProject[];
}

interface getPositionListByProjectError {
  type: typeof GET_POSITION_LIST_BY_PROJECT_ERROR;
  payload: string;
}

interface getNavCandidateSearchSuccess {
  type: typeof GET_NAV_CANDIDATE_SEARCH_SUCCESS;
  payload: NavCandidateListItem[];
}

interface getNavCandidateSearchError {
  type: typeof GET_NAV_CANDIDATE_SEARCH_ERROR;
  payload: string;
}

interface getCustomerListSuccess {
  type: typeof GET_ALL_CUSTOMER_SUCCESS;
  payload: CustomerList[];
}

interface getCustomerListError {
  type: typeof GET_ALL_CUSTOMER_ERROR;
  payload: string;
}
interface getPassiveCustomerListSuccess {
  type: typeof GET_ALL_PASSIVE_CUSTOMER_SUCCESS;
  payload: PassiveCustomerList[];
}

interface getPassiveCustomerListError {
  type: typeof GET_ALL_PASSIVE_CUSTOMER_ERROR;
  payload: string;
}
interface getPersonnelNameForProjectAssignmentSuccess {
  type: typeof GET_PERSONNEL_NAME_FOR_PROJECT_ASSIGNMENT_SUCCESS;
  payload: PersonnelNameForProjectAssignmentList[];
}

interface getPersonnelNameForProjectAssignmentError {
  type: typeof GET_PERSONNEL_NAME_FOR_PROJECT_ASSIGNMENT_ERROR;
  payload: string;
}
interface getComponiesSuccess {
  type: typeof GET_COMPANIES_SUCCESS;
  payload: Companies[];
}

interface getComponiesError {
  type: typeof GET_COMPANIES_ERROR;
  payload: string;
}

interface getCostCenterListSuccess {
  type: typeof GET_COST_CENTER_SUCCESS;
  payload: CostCenter[];
}

interface getCostCenterListError {
  type: typeof GET_COST_CENTER_ERROR;
  payload: string;
}

interface getMyUserDetailListSuccess {
  type: typeof GET_MY_USER_DETAIL_SUCCESS;
  payload: UserDetail[];
}

interface getMyUserDetailListError {
  type: typeof GET_MY_USER_DETAIL_ERROR;
  payload: string;
}
interface getFirmNamesSuccess {
  type: typeof GET_FİRM_NAMES_SUCCESS;
  payload: Firm[];
}

interface getFirmNamesError {
  type: typeof GET_FİRM_NAMES_ERROR;
  payload: string;
}
interface getStartingWorkEmployeesSuccess {
  type: typeof GET_STARTİNG_WORK_EMPLOYEES_SUCCESS;
  payload: StartingWorkEmployees[];
}

interface getStartingWorkEmployeesError {
  type: typeof GET_STARTİNG_WORK_EMPLOYEES_ERROR;
  payload: string;
}
interface getRelatedMemberNameListSuccess {
  type: typeof GET_RELATED_MEMBER__NAME_LİST_SUCCESS;
  payload: StartingWorkEmployees[];
}

interface getRelatedMemberNameListError {
  type: typeof GET_RELATED_MEMBER__NAME_LİST_ERROR;
  payload: string;
}

interface getPersonalTypeListSuccess {
  type: typeof GET_PERSONAL_TYPE_LİST_SUCCESS;
  payload: StartingWorkEmployees[];
}

interface getPersonalTypeListError {
  type: typeof GET_PERSONAL_TYPE_LİST_ERROR;
  payload: string;
}

interface getProjectNameListSuccess {
  type: typeof GET_PROJECT_NAME_LİST_SUCCESS;
  payload: StartingWorkEmployees[];
}

interface getProjectNameListError {
  type: typeof GET_PROJECT_NAME_LİST_ERROR;
  payload: string;
}

interface getProjectAssignmentListSuccess {
  type: typeof GET_PROJECT_ASSİGNMENT_LİST_SUCCESS;
  payload: ProjectAssignmentList[];
}

interface getProjectAssignmentListError {
  type: typeof GET_PROJECT_ASSİGNMENT_LİST_ERROR;
  payload: string;
}

interface getLeavingPersonalListSuccess {
  type: typeof GET_LEAVİNG_PERSONAL_LİST_SUCCESS;
  payload: LeavingPersonalList[];
}

interface getLeavingPersonalListError {
  type: typeof GET_LEAVİNG_PERSONAL_LİST_ERROR;
  payload: string;
}

interface getAllPersonnelListSuccess {
  type: typeof GET_ALL_PERSONNEL_LİST_SUCCESS;
  payload: AllPersonnel[];
}

interface getAllPersonnelListError {
  type: typeof GET_ALL_PERSONNEL_LİST_ERROR;
  payload: string;
}

interface getAllMemberListForPositionSuccess {
  type: typeof GET_ALL_MEMBER_LİST_FOR_POSİTİON_SUCCESS;
  payload: AllMemberListForPosition[];
}

interface getAllMemberListForPositionError {
  type: typeof GET_ALL_MEMBER_LİST_FOR_POSİTİON_ERROR;
  payload: string;
}

interface getMainTechnologiesListSuccess {
  type: typeof GET_MAIN_TECHNOLOGIES_LIST_SUCCESS;
  payload: MainTechnologiesList[];
}

interface getMainTechnologiesListError {
  type: typeof GET_MAIN_TECHNOLOGIES_LIST_ERROR;
  payload: string;
}

interface getSubTechnologiesListSuccess {
  type: typeof GET_SUB_TECHNOLOGIES_LIST_SUCCESS;
  payload: SubTechnologiesList[];
}

interface getSubTechnologiesListError {
  type: typeof GET_SUB_TECHNOLOGIES_LIST_ERROR;
  payload: string;
}

interface getLanguageListSuccess {
  type: typeof GET_LANGUAGE_LİST_SUCCESS;
  payload: LanguageList[];
}

interface getLanguageListError {
  type: typeof GET_LANGUAGE_LİST_ERROR;
  payload: string;
}

interface getLanguageLevelListSuccess {
  type: typeof GET_LANGUAGE_LEVEL_LİST_SUCCESS;
  payload: LanguageLevelList[];
}

interface getLanguageLevelListError {
  type: typeof GET_LANGUAGE_LEVEL_LİST_ERROR;
  payload: string;
}

interface getCountryListSuccess {
  type: typeof GET_COUNTRY_LİST_SUCCESS;
  payload: CountryList[];
}

interface getCountryListError {
  type: typeof GET_COUNTRY_LİST_ERROR;
  payload: string;
}

interface getCityListSuccess {
  type: typeof GET_CITY_LİST_SUCCESS;
  payload: CityList[];
}

interface getCityListError {
  type: typeof GET_CITY_LİST_ERROR;
  payload: string;
}

interface getTownListByCitySuccess {
  type: typeof GET_TOWN_LİST_BY_CITY_SUCCESS;
  payload: TownList[];
}

interface getTownListByCityError {
  type: typeof GET_TOWN_LİST_BY_CITY_ERROR;
  payload: string;
}

interface getCollageListSuccess {
  type: typeof GET_COLLAGE_LİST_SUCCESS;
  payload: CollageList[];
}

interface getCollageListError {
  type: typeof GET_COLLAGE_LİST_ERROR;
  payload: string;
}

interface getDepartmentListSuccess {
  type: typeof GET_DEPARTMENT_LİST_SUCCESS;
  payload: DepartmentList[];
}

interface getDepartmentListError {
  type: typeof GET_DEPARTMENT_LİST_ERROR;
  payload: string;
}

interface getTechnicalSelectTreeListSuccess {
  type: typeof GET_TECHNICICAL_SELECT_TREE_LIST_SUCCESS;
  payload: TechnicalSelectTreeList[];
}

interface getTechnicalSelectTreeListError {
  type: typeof GET_TECHNICICAL_SELECT_TREE_LIST_ERROR;
  payload: string;
}

interface getTechnicGroupMainListSuccess {
  type: typeof GET_TECHNİC_GROUP_MAİN_LİST_SUCCESS;
  payload: TechnicGroupMainList[];
}

interface getTechnicGroupMainListError {
  type: typeof GET_TECHNİC_GROUP_MAİN_LİST_ERROR;
  payload: string;
}

interface getAllTechnicalGroupSuccess {
  type: typeof GET_ALL_TECHNICAL_GROUP_SUCCESS;
  payload: TechnicalList[];
}

interface getAllTechnicalGroupError {
  type: typeof GET_ALL_TECHNICAL_GROUP_ERROR;
  payload: string;
}

interface getDomainMainGroupListSuccess {
  type: typeof GET_DOMAİN_MAİN_GROUP_LİST_SUCCESS;
  payload: DomainMainGroupList[];
}

interface getDomainMainGroupListError {
  type: typeof GET_DOMAİN_MAİN_GROUP_LİST_ERROR;
  payload: string;
}

interface getDomainSubGroupListSuccess {
  type: typeof GET_DOMAİN_SUB_GROUP_LİST_SUCCESS;
  payload: DomainSubGroupList[];
}

interface getDomainSubGroupListError {
  type: typeof GET_DOMAİN_SUB_GROUP_LİST_ERROR;
  payload: string;
}

interface getSearchedPersonelDetailSuccess {
  type: typeof GET_SEARCHED_PERSONEL_DETAIL_SUCCESS;
  payload: Member[];
}

interface getMemberCollageListSuccess {
  type: typeof GET_MEMBER_COLLAGE_LİST_SUCCESS;
  payload: MemberCollageList[];
}

interface getMemberCollageListError {
  type: typeof GET_MEMBER_COLLAGE_LİST_ERROR;
  payload: string;
}

interface getMemberTechnicListSuccess {
  type: typeof GET_MEMBER_TECHNİC_LİST_SUCCESS;
  payload: MemberTechnicList[];
}

interface getMemberTechnicListError {
  type: typeof GET_MEMBER_TECHNİC_LİST_ERROR;
  payload: string;
}
interface getPersonalCommunicationLevelListSuccess {
  type: typeof GET_PERSONAL_COMMUNİCATİON_LEVEL_LİST_SUCCESS;
  payload: PersonalCommunicationLevelList[];
}

interface getPersonalCommunicationLevelListError {
  type: typeof GET_PERSONAL_COMMUNİCATİON_LEVEL_LİST_ERROR;
  payload: string;
}
interface getGraduationStatusListSuccess {
  type: typeof GET_GRADUATION_STATUS_LIST_SUCCESS;
  payload: GraduationStatusList[];
}
interface getGraduationStatusListError {
  type: typeof GET_GRADUATION_STATUS_LIST_ERROR;
  payload: string;
}
interface getMilitaryServiceStatusListSuccess {
  type: typeof GET_MILITARY_SERVICE_STATUS_LIST_SUCCESS;
  payload: MilitaryServiceStatusList[];
}
interface getMilitaryServiceStatusListError {
  type: typeof GET_MILITARY_SERVICE_STATUS_LIST_ERROR;
  payload: string;
}
interface getDriversLicenseListSuccess {
  type: typeof GET_DRIVERS_LICENSE_LIST_SUCCESS;
  payload: DriversLicenseList[];
}
interface getDriversLicenseListError {
  type: typeof GET_DRIVERS_LICENSE_LIST_ERROR;
  payload: string;
}
interface getTechnicListSuccess {
  type: typeof GET_TECHNIC_LIST_SUCCESS;
  payload: TechnicList[];
}
interface getTechnicListError {
  type: typeof GET_TECHNIC_LIST_ERROR;
  payload: string;
}
interface getPersonalAbilityListSuccess {
  type: typeof GET_PERSONAL_ABİLİTY_LİST_SUCCESS;
  payload: PersonalAbilityList[];
}

interface getPersonalAbilityListError {
  type: typeof GET_PERSONAL_ABİLİTY_LİST_ERROR;
  payload: string;
}

interface getCommunicationParameterListSuccess {
  type: typeof GET_COMMUNICATION_PARAMETER_LIST_SUCCESS;
  payload: CommunicationParameterList[];
}

interface getCommunicationParameterListError {
  type: typeof GET_COMMUNICATION_PARAMETER_LIST_ERROR;
  payload: string;
}

export interface MainTechnologiesList {}

export interface AllMemberListForPosition {}

export type getProjectDetailSuccess = {
  type: typeof GET_PROJECT_DETAIL_SUCCESS;
  payload: any;
};

export type getProjectDetailError = {
  type: typeof GET_PROJECT_DETAIL_ERROR;
  payload: string;
};

export type getProjectStatusParameterSuccess = {
  type: typeof GET_PROJECT_STATUS_PARAMETER_SUCCESS;
  payload: any;
};

export type getProjectStatusParameterError = {
  type: typeof GET_PROJECT_STATUS_PARAMETER_ERROR;
  payload: string;
};

export type getCapacityInfoSuccess = {
  type: typeof GET_CAPACITY_INFO_SUCCESS;
  payload: any;
};

export type getCapacityInfoError = {
  type: typeof GET_CAPACITY_INFO_ERROR;
  payload: string;
};

export type memberActions =
  | getCostCenterListSuccess
  | getCustomerListSuccess
  | getCustomerListError
  | getCostCenterListError
  | getComponiesSuccess
  | getComponiesError
  | getMyUserDetailListSuccess
  | getMyUserDetailListError
  | getFirmNamesError
  | getFirmNamesSuccess
  | getStartingWorkEmployeesSuccess
  | getStartingWorkEmployeesError
  | getRelatedMemberNameListSuccess
  | getRelatedMemberNameListError
  | getPersonalTypeListSuccess
  | getPersonalTypeListError
  | getPersonalTypeListSuccess
  | getProjectNameListError
  | getProjectNameListSuccess
  | getProjectAssignmentListSuccess
  | getProjectAssignmentListError
  | getPassiveCustomerListSuccess
  | getPassiveCustomerListError
  | getPersonnelNameForProjectAssignmentSuccess
  | getPersonnelNameForProjectAssignmentError
  | getLeavingPersonalListSuccess
  | getLeavingPersonalListError
  | getAllPersonnelListSuccess
  | getAllPersonnelListError
  | getAllMemberListForPositionSuccess
  | getAllMemberListForPositionError
  | getMainTechnologiesListSuccess
  | getMainTechnologiesListError
  | getSubTechnologiesListSuccess
  | getSubTechnologiesListError
  | getLanguageListSuccess
  | getLanguageListError
  | getLanguageLevelListSuccess
  | getLanguageLevelListError
  | getCountryListSuccess
  | getCountryListError
  | getCityListSuccess
  | getCityListError
  | getTownListByCitySuccess
  | getTownListByCityError
  | getCollageListSuccess
  | getCollageListError
  | getDepartmentListSuccess
  | getDepartmentListError
  | getTechnicalSelectTreeListSuccess
  | getTechnicalSelectTreeListError
  | getTechnicGroupMainListSuccess
  | getTechnicGroupMainListError
  | getAllTechnicalGroupSuccess
  | getAllTechnicalGroupError
  | getDomainMainGroupListSuccess
  | getDomainMainGroupListError
  | getDomainSubGroupListSuccess
  | getDomainSubGroupListError
  | getSearchedPersonelDetailSuccess
  | getMemberCollageListSuccess
  | getMemberCollageListError
  | getMemberTechnicListSuccess
  | getMemberTechnicListError
  | getProjectDetailSuccess
  | getProjectDetailError
  | getProjectStatusParameterSuccess
  | getProjectStatusParameterError
  | getCapacityInfoSuccess
  | getCapacityInfoError
  | getPositionListSuccess
  | getPositionListError
  | getPositionListTechnicGroupSuccess
  | getPositionListTechnicGroupError
  | getPositionListByCompanySuccess
  | getPositionListByCompanyError
  | getPositionListByProjectSuccess
  | getPositionListByProjectError
  | getNavCandidateSearchSuccess
  | getNavCandidateSearchError
  | { type: typeof GET_PROJECT_PERSONNEL_SALARY_SUCCESS; payload: any }
  | { type: typeof GET_PROJECT_PERSONNEL_SALARY_ERROR; payload: string }
  | { type: typeof GET_INSOURCE_PERSONAL_SUCCESS; payload: any }
  | { type: typeof GET_INSOURCE_PERSONAL_ERROR; payload: string }
  | { type: typeof GET_FILTER_SECTION_PROJECT_INFO_SUCCESS; payload: any }
  | { type: typeof GET_FILTER_SECTION_PROJECT_INFO_ERROR; payload: string }
  | { type: typeof GET_PROJECT_CLOSING_REPORT_SUCCESS; payload: any }
  | { type: typeof GET_PROJECT_CLOSING_REPORT_ERROR; payload: string }
  | { type: typeof GET_ALL_VERSIONS_SUCCESS; payload: any }
  | { type: typeof GET_ALL_VERSIONS_ERROR; payload: string }
  | { type: typeof CREATE_VERSION_SUCCESS; payload: any }
  | { type: typeof CREATE_VERSION_ERROR; payload: string }
  | { type: typeof UPDATE_VERSION_SUCCESS; payload: any }
  | { type: typeof UPDATE_VERSION_ERROR; payload: string }
  | { type: typeof DELETE_VERSION_SUCCESS; payload: any }
  | { type: typeof DELETE_VERSION_ERROR; payload: string }
  | getPersonalCommunicationLevelListSuccess
  | getPersonalCommunicationLevelListError
  | getGraduationStatusListSuccess
  | getGraduationStatusListError
  | getMilitaryServiceStatusListSuccess
  | getMilitaryServiceStatusListError
  | getDriversLicenseListSuccess
  | getDriversLicenseListError
  | getTechnicListSuccess
  | getTechnicListError
  | getPersonalAbilityListSuccess
  | getPersonalAbilityListError
  | getCommunicationParameterListSuccess
  | getCommunicationParameterListError;
